import axios from "axios";
import Store from "../store";
import { LOGOUT } from "../store/Types/AuthTypes";
import { BASE_URL } from "../config/apiConfig";

const backendValidUser = axios.create({
 //baseURL: "http://localhost:7001/admin",
   baseURL: "https://be.lotusmart.com.pk/admin",
});

backendValidUser.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("myToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error("[Axios Request Error] backendValidUser:", error);
    return Promise.reject(error);
  }
);

backendValidUser.interceptors.response.use(
  (response) => response,
  (error) => {
    const shouldLogout =
      error.response && error.response.status === 401;

    if (shouldLogout) {
      localStorage.clear();
      Store.dispatch({ type: LOGOUT });

      const loginPath = "/";
      if (window.location.pathname !== loginPath) {
        window.location.href = loginPath;
      }
    } else {
      console.error("[Axios Response Error] backendValidUser:", error);
    }

    return Promise.reject(error);
  }
);

export default backendValidUser;
